import ButtonsBlock from '@/components/common/buttons-block/buttons-block';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import { GROUP_USERS, USERS } from '@/utils/CONST';
import { composeUri } from '@/utils/compose';
import { DeleteOutlined } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useDelete, useNotify, useTranslate, useUpdate } from 'react-admin';
import { useNavigate, useParams } from 'react-router';

const DeleteUserDialog = () => {
    const { userId = '', agencyId = '' } = useParams();
    const navigate = useNavigate();
    const translate = useTranslate();
    const [deleteOne, { isLoading: isLoadingDelete }] = useDelete();
    const [update, { isLoading: isLoadingUpdate }] = useUpdate();
    const notify = useNotify();

    const userUriId = composeUri(USERS, userId);

    const navigateBack = () => {
        navigate(-1);
    };

    const handleDelete = () => {
        update(
            USERS,
            {
                id: `${userUriId}/remove_group_users`,
                data: {
                    groupUsers: [composeUri(GROUP_USERS, agencyId)],
                },
            },
            {
                onSuccess: () => {
                    deleteOne(
                        USERS,
                        {
                            id: userUriId,
                            meta: {
                                requestType: 'update',
                                id: `${userUriId}/hide`,
                                data: {
                                    hide: true,
                                },
                            },
                        },
                        {
                            onSuccess: () => {
                                notify('ra.notification.deleted', {
                                    type: 'success',
                                    messageArgs: { smart_count: 1 },
                                });
                                navigateBack();
                            },
                            mutationMode: 'optimistic',
                        },
                    );
                },
            },
        );
    };

    return (
        <DialogTemplate
            icon={<DeleteOutlined />}
            title={translate('ra.action.delete')}
            open={true}
            onClose={navigateBack}
        >
            <Box display={'grid'} gap={2}>
                <Typography>{translate('errorMessages.delete_label')}</Typography>

                <ButtonsBlock>
                    <Button onClick={navigateBack}>{translate('ra.action.cancel')}</Button>

                    <LoadingButton
                        data-cy={'confirm-delete'}
                        variant={'contained'}
                        onClick={handleDelete}
                        loading={isLoadingDelete || isLoadingUpdate}
                    >
                        {translate('ra.action.delete')}
                    </LoadingButton>
                </ButtonsBlock>
            </Box>
        </DialogTemplate>
    );
};

export default DeleteUserDialog;
